declare var angular: any;
import * as _ from 'underscore';

import * as dropin from 'braintree-web-drop-in';

angular
  .module('GlobalControllers')

  .controller('NotPricingCtrl', [
    '$scope',
    'pricing',
    function($scope, pricing) {
      $scope.prices = pricing.getPrices();
    }
  ])

  .component('billingHistory', {
    templateUrl: '/ng1/www/modules/global/payment/html/history.html',
    controller: [
      '$scope',
      'api',
      '$location',
      '$mdToast',
      'API_URL',
      'FileSaver',
      '$http',
      async function(
        $scope,
        api,
        $location,
        $mdToast,
        API_URL,
        FileSaver,
        $http
      ) {
        $scope.bills = await api.getBillingHistory();

        $scope.download = billId => {
          $mdToast.show(
            $mdToast
              .simple()
              .hideDelay(4000)
              .textContent('Votre facture arrive 🚀')
              .position('bottom right')
          );

          $http({
            url: `${API_URL}/bills/${billId}`,
            method: 'GET',
            headers: {
              'Content-type': 'application/pdf; charset=utf-8',
              'X-Auth-Token': api.data.token
            },
            responseType: 'arraybuffer'
          })
            .success(function(data, status, headers) {
              var filename = 'facture';

              var blob = new Blob([data], { type: 'application/pdf' });
              FileSaver.saveAs(blob, filename);
            })
            .error(function(data, status) {
              console.log('Request failed with status: ' + status);
            });
        };
      }
    ]
  })

  .controller('PaymentCtrl', [
    '$scope',
    '$location',
    '$mdToast',
    'api',
    'navbar',
    'pricing',
    '$window',
    '$timeout',
    async function(
      $scope,
      $location,
      $mdToast,
      api,
      navbar,
      pricing,
      $window,
      $timeout
    ) {
      if ((window as any).fbq) {
        (window as any).fbq('track', 'Lead');
      }

      var swapArrayElements = function(a, x, y) {
        console.log('arr', a);
        var b = a[y];
        a[y] = a[x];
        a[x] = b;
        return a;
      };

      navbar.goBackAction('Retour', '#!/', 'navbar.back');

      $scope.data = {};

      pricing.getPrices$().then(async function(prices) {
        $scope.prices = swapArrayElements(prices, 1, 2);

        $scope.prices[1] = {
          ...$scope.prices[1],
          text: 'Le plus populaire'
        };

        $scope.prices[3] = {
          ...$scope.prices[3],
          text: 'Meilleur prix'
        };

        // TODO refactor custom for toeic
        let activation_codes: any[] = await api.getActivationsCode();
        console.log('activation_codes', activation_codes);
        let hasCustomCode = activation_codes.find(
          code => code.code === 'NATH-TOEIC-30'
        );
        if (hasCustomCode) {
          $scope.promocode = 'NATH-TOEIC-30';
          applyPromoCode();
        }
      });

      $scope.promocode = null;

      $scope.addPromoCode = async () => {
        let x = window.prompt('Quel est votre code promo ?');
        if (x) {
          $scope.promocode = x.toUpperCase();
        } else {
          return;
        }
        try {
          await applyPromoCode();
        } catch (err) {
          $scope.prices = $scope.prices.map(price => {
            return _.omit(price, 'newPrice', 'newPricePerDay');
          });

          $scope.promocode = null;
          $scope.findGoodPlan($scope.choosePlan);

          $mdToast.show(
            $mdToast
              .simple()
              .hideDelay(6000)
              .textContent("Ce code promo n'est pas valide")
              .position('bottom right')
          );
        }
      };

      async function applyPromoCode() {
        let promoPrices = await api.getPrices($scope.promocode);
        $scope.prices = $scope.prices.map(price => {
          console.log('tt', promoPrices[price.value]);
          return {
            ...price,
            newPrice: promoPrices[price.value],
            newPricePerDay: parseFloat(
              ((promoPrices[price.value] as any) / price.value) as any
            ).toPrecision(2)
          };
        });
        console.log('$scope.prices', $scope.prices);
        $scope.findGoodPlan($scope.choosePlan);
      }

      $scope.findGoodPlan = function(plan) {
        $scope.choosePlan = plan;
        var indexedPrices = _.indexBy($scope.prices, 'value');
        $scope.selectedPlan = indexedPrices[plan];
      };

      var getOptions = $location.search();
      if (getOptions['plan']) {
        $scope.choosePlan = getOptions['plan'];
      } else {
        $scope.choosePlan = '92';
      }
      $scope.$watch(
        function() {
          return $scope.prices ? $scope.prices.length : null;
        },
        function() {
          $scope.findGoodPlan($scope.choosePlan);
        }
      );

      api.me().then(function(data) {
        $scope.firstName = data.user.first_name;
        $scope.lastName = data.user.last_name;
        $scope.address = data.user.address;
        $scope.postalCode = data.user.postal_code;
        $scope.city = data.user.city;
        $scope.email = data.user.email;
      });
      $scope.country = 'France';

      var submit = function(nonce) {
        $scope.loading = true;
        api
          .checkout(
            nonce,
            $scope.choosePlan,
            $scope.firstName,
            $scope.lastName,
            $scope.address,
            $scope.postalCode,
            $scope.city,
            $scope.promocode
          )
          .then(
            function(data) {
              delete $window.localStorage.dateOfRegister;
              api.me();
              $scope.finished = true;
            },
            function(error) {
              $mdToast.show(
                $mdToast
                  .simple()
                  .hideDelay(6000)
                  .textContent(
                    "Votre paiement n'a pas été validé, veuillez utiliser un autre mode de paiement "
                  )
                  .position('bottom right')
              );

              $scope.loading = false;
            }
          );

        if ((window as any).fbq) {
          (window as any).fbq('track', 'Purchase');
        }
      };

      var init_braintree = function() {
        api.getPaymentToken().then(function(data) {
          var clientToken = data.token;
          dropin.create(
            {
              authorization: clientToken,
              container: '#checkout',
              threeDSecure: true,
              paypal: {
                flow: 'vault'
              },
              locale: 'fr_FR',
              translations: {
                chooseAWayToPay: 'Votre méthode de paiement'
              }
            },
            function(createErr, instance) {
              $scope.submit = function() {
                $scope.loading = true;

                const threeDSecureParameters = {
                  amount:
                    $scope.selectedPlan.newPrice || $scope.selectedPlan.price,
                  email: $scope.email,

                  billingAddress: {
                    givenName: ($scope.firstName as string)
                      ?.normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, ''), // ASCII-printable characters required, else will throw a validation error
                    surname: ($scope.lastName as string)
                      ?.normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, ''), // ASCII-printable characters required, else will throw a validation error
                    streetAddress: $scope.address,
                    locality: $scope.city,
                    postalCode: $scope.postalCode
                  }
                };

                instance.requestPaymentMethod(
                  {
                    threeDSecure: threeDSecureParameters
                  },
                  function(err, payload) {
                    $scope.loading = false;

                    if (!err) {
                      submit(payload.nonce);
                    } else {
                      $scope.step2.completed = false;
                      $scope.selected = 1;
                    }
                  }
                );
              };
            }
          );
        });
      };

      $timeout(function() {
        init_braintree();
      }, 200);
    }
  ]);
